import React from 'react';
import alertify from 'alertifyjs';

import API, {handleError} from 'utils/xhr';


export class SubscribeForm extends React.Component {

  state = {
    email: '',
  }

  onSubscribe(e){
    e.preventDefault();

    const url = '/public/subscribe';
    const data = {'email': this.state.email}
    API.post(url, data).then(response =>{
      const state = this.state;
      state.email = '';
      alertify.warning('Subscribed!', 1.5);  
      this.setState(state);
    },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }

  onChange(e){
    const state = this.state;
    state.email = e.target.value;
    this.setState(state);
  }
  
  render (){
    const force_full_width = this.props.full_width || false;
    return (
      <div className="my-2  flex-center">
        <div className={"input-group p-3 " + ((force_full_width)? ' col-12 ':' col-md-6 ')}>
          <input 
            className="form-control btn-rounded py-3" 
            type="email" 
            placeholder="Email address"
            
            onChange={this.onChange.bind(this)}
            value={this.state.email} />
          <div className="input-group-append">
            <a className="btn input-group-text btn-rounded bg-dark text-white" style={{border: '0px'}} href='/' onClick={this.onSubscribe.bind(this)} >Subscribe</a>
          </div>
        </div>
        <p className="mt-1 mb-3 text-spacing-3 small family-code uppercase text-white">For updates on new ByteBeacon releases</p>
      </div>
    )
  }
}
